import api from './config';
import { 
  LoginRequest, 
  CreateUserRequest, 
  ApiResponse, 
  User, 
  SoftwareUpdateRecord
} from '../types';

// 软件更新记录API
export const updateHistoryApi = {
  // 获取所有软件更新记录
  getAllRecords: () => api.get<ApiResponse<SoftwareUpdateRecord[]>>('/updates'),
  
  // 获取特定软件的更新记录
  getRecordsBySoftware: (softwareName: string) => 
    api.get<ApiResponse<SoftwareUpdateRecord[]>>(`/updates/software/${softwareName}`),
  
  // 获取特定软件的最新版本
  getLatestVersion: (softwareName: string) => 
    api.get<ApiResponse<{ softwareName: string, version: string }>>(`/updates/software/${softwareName}/latest`),
  
  // 创建新的更新记录 - 修改以适应后端结构
  createRecord: (record: Omit<SoftwareUpdateRecord, 'id' | 'createdAt' | 'updatedAt'>) => {
    // 确保包含必要字段
    const payload = {
      softwareName: record.softwareName,
      version: record.version,
      updateDate: record.updateDate,
      content: record.content,
      title: record.title || '',
      contentFilePath: record.contentFilePath || '', // 确保有此字段，即使为空
      downloadLinks: record.downloadLinks || [] // 添加downloadLinks字段
    };
    return api.post<ApiResponse<SoftwareUpdateRecord>>('/updates', payload);
  },
  
  // 更新已有记录
  updateRecord: (id: string, record: Partial<SoftwareUpdateRecord>) => {
    // 确保包含所需字段
    const payload = {
      ...record,
      // 如果有updateDate字段，确保它是字符串格式
      ...(record.updateDate && typeof record.updateDate === 'object'
        ? { updateDate: (record.updateDate as any).format?.('YYYY-MM-DD') || record.updateDate } 
        : {}),
      // 确保downloadLinks字段被包含
      downloadLinks: record.downloadLinks || []
    };
    return api.put<ApiResponse<SoftwareUpdateRecord>>(`/updates/${id}`, payload);
  },
  
  // 删除记录
  deleteRecord: (id: string) => 
    api.delete<ApiResponse<void>>(`/updates/${id}`),
};

// 用户认证API
export const authApi = {
  // 用户登录
  login: (credentials: LoginRequest) => 
    api.post<any>('/auth/login', credentials),
  
  // 验证当前令牌
  validateToken: () => 
    api.get<any>('/auth/me'),
};

// 用户管理API
export const userApi = {
  // 获取所有用户
  getAllUsers: () => 
    api.get<ApiResponse<User[]>>('/users'),
  
  // 创建新用户
  createUser: (user: CreateUserRequest) => {
    // 确保Role是字符串格式
    const payload = {
      username: user.username,
      password: user.password,
      role: user.role
    };
    return api.post<ApiResponse<User>>('/users', payload);
  },
  
  // 删除用户
  deleteUser: (id: string) => 
    api.delete<ApiResponse<void>>(`/users/${id}`),
    
  // 修改用户密码
  changePassword: (id: string, newPassword: string) => {
    const payload = { newPassword };
    return api.put<ApiResponse<void>>(`/users/${id}/password`, payload);
  }
}; 